import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { JsonApiIndexResponse } from '@app/interfaces';
import { ApplicantInterviews } from '@app/models/recruiting/applicant-interviews.model';
import { InterviewQuestion } from '@app/models/recruiting/interview-question.model';
import { ApplicantTrackerResources } from '../applicant-tracker.resource';
import {
    Attach,
    Detach,
    InterviewAssignAttributes,
    InterviewAssignJSONApiRequest,
} from '../interfaces/interviews-assign.interface';

@Injectable()
export class InterviewService {
    constructor(private http: HttpClient) {}

    async assignApplicantToInterview(
        interviewId: number,
        feedbackDueDate: string,
        applicantId: number,
        attach?: Attach,
        detach?: Detach
    ): Promise<void> {
        // Create payload for assignment request.
        const payload: InterviewAssignJSONApiRequest = {
            data: [
                {
                    attributes: {
                        attach,
                        detach,
                        feedback_due_date: feedbackDueDate,
                        applicant_id: applicantId,
                    },
                },
            ],
        };

        await this.http
            .post(ApplicantTrackerResources.AssignInterviews.replace(':interview', interviewId.toString()), payload)
            .toPromise();
    }

    async getApplicantInterviewFeedbackResults(applicantInterview: ApplicantInterviews): Promise<InterviewQuestion[]> {
        const applicantInterviewFeedbackResultsUrl = `/v2/applicantTracker/applicantInterviews/${applicantInterview.id}/feedbackResults`;

        const res = await this.http
            .get<JsonApiIndexResponse<InterviewQuestion>>(applicantInterviewFeedbackResultsUrl)
            .toPromise();

        const data = res.data.map((interviewQuestions) => {
            return {
                data: { ...interviewQuestions },
                included: res.included,
            };
        });

        const interviewQuestionsWithFeedbackResults: InterviewQuestion[] = (data as Array<Record<string, unknown>>).map(
            (question) => new InterviewQuestion(question)
        );

        return interviewQuestionsWithFeedbackResults;
    }

    async assignMultipleApplicantToInterview(
        interviewId: number,
        interviewAssignAttributes: InterviewAssignAttributes[]
    ): Promise<void> {
        const payload: InterviewAssignJSONApiRequest = {
            data: [...interviewAssignAttributes],
        };

        await this.http
            .post(ApplicantTrackerResources.AssignInterviews.replace(':interview', interviewId.toString()), payload)
            .toPromise();
    }
}
